import { createFileRoute } from '@tanstack/react-router'
import EmployeeAssetsDashboard from '@/features/employee-assets-dashboard'
import { ProtectedRoute } from '@/components/auth/protected-route'
import { Permissions } from '@/constants/roles-permissions'

export const Route = createFileRoute('/_authenticated/employee-assets-dashboard')({
  component: EmployeeAssetsDashboardRoute,
})

function EmployeeAssetsDashboardRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeAssetView}>
      <EmployeeAssetsDashboard />
    </ProtectedRoute>
  )
}   